import React from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Chip,
} from '@mui/material';
import {
  Brightness4,
  Brightness7,
  Logout,
  Dashboard,
  AdminPanelSettings,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useThemeMode } from '../contexts/ThemeContext';

function Navbar({ currentView, setCurrentView }) {
  const { logout, isAdmin, currentUser } = useAuth();
  const { isDarkMode, toggleTheme } = useThemeMode();

  // Debug logging for admin detection
  React.useEffect(() => {
    console.log('Navbar - isAdmin:', isAdmin, 'currentUser:', currentUser);
  }, [isAdmin, currentUser]);

  return (
    <AppBar position="static" sx={{ mb: 3 }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 700 }}>
          Trauma Network Tools
        </Typography>
        
        {/* User Role Indicator */}
        {currentUser && (
          <Chip 
            label={currentUser.role === 'admin' ? 'Admin' : 'User'}
            color={currentUser.role === 'admin' ? 'secondary' : 'default'}
            size="small"
            sx={{ mr: 2 }}
          />
        )}
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Navigation Buttons */}
          <Button
            color={currentView === 'dashboard' ? 'secondary' : 'inherit'}
            onClick={() => setCurrentView('dashboard')}
            startIcon={<Dashboard />}
            variant={currentView === 'dashboard' ? 'contained' : 'text'}
            size="small"
          >
            Tools
          </Button>
          
          {/* Admin Panel Button - Only visible to admins */}
          {isAdmin && (
            <Button
              color={currentView === 'admin' ? 'secondary' : 'inherit'}
              onClick={() => setCurrentView('admin')}
              startIcon={<AdminPanelSettings />}
              variant={currentView === 'admin' ? 'contained' : 'text'}
              size="small"
            >
              Admin
            </Button>
          )}
          
          <IconButton
            color="inherit"
            onClick={toggleTheme}
            title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {isDarkMode ? <Brightness7 /> : <Brightness4 />}
          </IconButton>
          
          <Button
            color="inherit"
            onClick={logout}
            startIcon={<Logout />}
            sx={{ ml: 1 }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
